var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"overlay"},[_c('AlternativeAudioForm',{attrs:{"altType":_vm.altType,"onCloseAlt":_vm.onCloseAlt,"updateAssetList":_vm.updateAssetList,"hasDefaultAssets":_vm.hasDefaultAssets}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }